import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '明星黑料', path: '/category/mingxing-heiliao' },
  { label: '网红爆料', path: '/category/wanghong-baoliao' },
  { label: '社会热点', path: '/category/shehui-redian' },
  { label: '综艺吃瓜', path: '/category/zongyi-chigua' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-6 max-w-[1440px] mx-auto w-full">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap ${scrolled ? 'text-primary-600' : 'text-white'}`}>
            <i className="ri-fire-line mr-1"></i>
            黑料视频
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === item.path
                  ? scrolled
                    ? 'text-primary-600'
                    : 'text-white font-semibold'
                  : scrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-white/80 hover:text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              scrolled ? 'text-foreground-600 hover:text-primary-600' : 'text-white/70 hover:text-white'
            }`}
          >
            关于我们
          </Link>
          <button
            className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-sm"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${scrolled ? 'text-foreground-800' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}